import { useMemo, useRef } from 'react'
import { useState, useEffect, useCallback } from 'react'
import LoadingFull from '../../components/loading/LoadingFull'
import { OPERE_INFORMATION_POST } from '../../constants/wordpress'
import { getPost } from '../../services/posts'
import './Opere.css'
import { debounce } from 'lodash'
import FooterOpere from '../../components/footerOpere/FooterOpere'
import Slideshow from '../../components/slideshow/Slideshow'
import { INSTAGRAM_OPERE_URL } from '../../constants/social'
import NavbarOpere from '../../components/navbarOpere/NavbarOpere'

const shuffleArray = (array) => {
  let currentIndex = array.length,
    randomIndex

  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--
      ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
  }

  return array
}

const footerFirstSection = (
  <div className="footer-first-section">
    <p />
    opere@corparquitetos.com
    <br />
    +351 911 020 079
    <br />
    +351 924 298 886
    <br />
    +351 218 274 373
    <p />
    Rua dos Lusíadas 5 2B, Lisboa
    <br />
    1300-365
    <p />
    <a target="_blank" href={INSTAGRAM_OPERE_URL} rel="noreferrer">
      Instagram
    </a>
  </div>
)

const parseOpereInformation = (information) => {
  const postContent = information.content.rendered

  const div = document.createElement('div')
  div.innerHTML = postContent

  const contentImages = div.getElementsByClassName('slideshow')

  if (!contentImages || !contentImages[0]) return false
  const elements = contentImages && contentImages[0].children

  const items = [].slice.call(elements)

  const images = items
    .map((item) => {
      const src = item.children[0].src
      const imageSrcSplit = src.split('?')
      const imageSrc = imageSrcSplit.length > 1 ? imageSrcSplit[0] : src
      return { image: imageSrc, caption: item.children[1].innerHTML }
    })
    .filter(({ image }) => image !== '')

  const contentDescription = div.getElementsByClassName('description')
  const secondSection = contentDescription[0].innerHTML
  const thirdSection = contentDescription[1].innerHTML

  return { images, secondSection, thirdSection }
}

const Opere = () => {
  const [informationPost, setInformationPost] = useState(null)

  const [loading, setLoading] = useState(true)

  const [hasScroll, setHasScroll] = useState(false)
  const [innerHeight, setInnerHeight] = useState(window.innerHeight)

  const slideshowIndexRef = useRef(0)
  const loadedImagesRef = useRef(new Set())

  const preloadNextImages = (currentIndex) => {
    if (!slideshowImages?.length) return

    for (let i = 1; i <= 3; i++) {
      const idx = (currentIndex + i) % slideshowImages.length
      const url = slideshowImages[idx].image

      if (!loadedImagesRef.current.has(url)) {
        const img = new Image()
        img.src = url
        loadedImagesRef.current.add(url)
      }
    }
  }

  useEffect(() => {
    setLoading(true)
    getPost(OPERE_INFORMATION_POST, (post) => {
      setInformationPost(post)
      setLoading(false)
      preloadNextImages(0)
    })
  }, [])

  useEffect(() => {
    const debouncedHandleResize = debounce(() => {
      setInnerHeight(window.innerHeight)
    }, 100)

    window.addEventListener('resize', debouncedHandleResize)

    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  }, [informationPost])

  const handlePage = useCallback(
    (node) => {
      if (!node) return
      setTimeout(() => {
        setHasScroll(node.clientHeight < node.scrollHeight)
      }, 200)
    },
    [innerHeight, informationPost]
  )

  const parsedInfo = useMemo(
    () => (informationPost ? parseOpereInformation(informationPost) : null),
    [informationPost]
  )

  const { images = [], secondSection = '', thirdSection = '' } = parsedInfo || {}

  const slideshowImages = useMemo(() => {
    return images?.length > 0 ? shuffleArray([...images]) : []
  }, [images])

  useEffect(() => {
    if (!slideshowImages.length) return
    const links = slideshowImages.slice(0, 5).map((img, i) => {
      const link = document.createElement('link')
      link.rel = 'preload'
      link.as = 'image'
      link.href = img.image
      link.fetchPriority = i === 0 ? 'high' : 'low'
      document.head.appendChild(link)
      return link
    })
    return () => links.forEach((l) => document.head.removeChild(l))
  }, [slideshowImages])

  const handleIndexChange = useCallback(
    (i) => {
      slideshowIndexRef.current = i
      preloadNextImages(i)
    },
    [slideshowImages]
  )

  return (
    <div className="page">
      <div className="page-scrollable-content opere-page" ref={handlePage}>
        <NavbarOpere opereMode={true} />
        {loading && <LoadingFull />}
        {slideshowImages?.length > 0 && (
          <Slideshow
            imageArray={slideshowImages}
            onIndexChange={handleIndexChange}
          />
        )}
        {/* <div className="opere-information-content-wrapper">
          {description && (
            <div
              className="opere-information-content"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div> */}
        {hasScroll && (
          <FooterOpere
            firstSection={footerFirstSection}
            secondSectionFooter={<div dangerouslySetInnerHTML={{ __html: secondSection }} />}
            thirdSectionFooter={<div dangerouslySetInnerHTML={{ __html: thirdSection }} />}
            containerStyle={{ marginTop: 0 }}
          />
        )}
      </div>
      {!hasScroll && (
        <FooterOpere
          firstSection={footerFirstSection}
          secondSectionFooter={<div dangerouslySetInnerHTML={{ __html: secondSection }} />}
          thirdSectionFooter={<div dangerouslySetInnerHTML={{ __html: thirdSection }} />}
        />
      )}
    </div>
  )
}

export default Opere
